<div class="control-box">
  @if (stepNbr > 0) {
    <span class="step">{{ stepNbr }}</span>
  }
  <img [src]="titleIcon" class="collectorIcon" />
  <div [innerHTML]="title" class="title"></div>
  <div [innerHTML]="subtitle" class="subtitle"></div>
  <div class="collectors">
    @for (r of data; track indexTrackBy(idx, r); let idx = $index) {
      <div>
        <input
          (ngModelChange)="onChange()"
          [(ngModel)]="data[idx]"
          [ngClass]="{ invalid: validationErrors && validationErrors.indexes[idx] }"
          [placeholder]="placeholderText.replace('{i}', idx + 1)"
          [title]="validationErrors && validationErrors.indexes[idx] ? validationErrors.message : ''"
          maxlength="64"
          minlength="5"
          name="input{{ idx }}"
          type="text"
          />
      </div>
    }
  </div>
  @if (allowAdd) {
    <div class="addButton">
      <div (click)="onAdd()" class="button">Add Another</div>
    </div>
  }
</div>
